module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Stainless Steel + Black Leather Closed.f26c030a.png";